// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3CgWB","signatureBlock":"Footer_signatureBlock__241ro","signature":"Footer_signature__3ZbJ4"};